var map = {
	"./balaclava-icon.png": 5948,
	"./belt-icon.png": 9084,
	"./bikini-icon.png": 5189,
	"./bling-icon.png": 1851,
	"./boxers-icon.png": 2958,
	"./cape-icon.png": 2890,
	"./crown-icon.png": 166,
	"./dress1-icon.png": 4439,
	"./dress2-icon.png": 8262,
	"./dress3-icon.png": 6313,
	"./frankie-icon.png": 9071,
	"./glasses-icon.png": 4105,
	"./hat-icon.png": 2352,
	"./hat2-icon.png": 5944,
	"./hoodie-icon.png": 2721,
	"./jacket-icon.png": 5691,
	"./overalls-icon.png": 1719,
	"./pants1-icon.png": 6544,
	"./pants2-icon.png": 4581,
	"./pants3-icon.png": 4853,
	"./shirt1-icon.png": 2358,
	"./shirt2-icon.png": 1031,
	"./shirt3-icon.png": 2804,
	"./shorts-icon.png": 926,
	"./skirt-icon.png": 5654,
	"./snorkel-icon.png": 5973,
	"./tanktop-icon.png": 9566,
	"./tie-icon.png": 4863,
	"./wetsuit-icon.png": 4008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3898;